import { useEffect } from 'react';
import { Platform } from 'react-native';
import { nativeBuildVersion } from 'expo-application';

import { useCheckUpdatesQuery } from './__generated__/checkUpdates.generated';
import { useAppUpdateInfo } from '../context';

export const useCheckUpdates = () => {
	const { updateInfo, setUpdateInfo, app } = useAppUpdateInfo();
	const { loading, error, data } = useCheckUpdatesQuery({
		skip: Platform.OS === 'web' || updateInfo.status === 'success',
		variables: {
			app,
			...Platform.select({
				android: {
					androidVersionCode: Number(nativeBuildVersion),
				},
				ios: {
					iOSBuildNumber: Number(nativeBuildVersion),
				},
			}),
		},
	});

	useEffect(() => {
		if (error) {
			setUpdateInfo({ status: 'error', error });

			return;
		}

		if (loading) {
			setUpdateInfo({ status: 'loading' });

			return;
		}

		if (data) {
			const {
				checkUpdates: { isUpdateRequired, availableUpdate },
			} = data;
			if (!availableUpdate) {
				setUpdateInfo({ status: 'success', availableUpdate: null });

				return;
			}

			setUpdateInfo({
				status: 'success',
				availableUpdate: {
					isRequired: isUpdateRequired,
					version: availableUpdate.version,
					releaseNotes: availableUpdate.releaseNotes ?? '',
				},
			});
		}
	}, [loading, error, data, setUpdateInfo]);

	return {
		updateInfo,
	};
};
